exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1cK1d{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex}._1SSsM{margin-right:10px;cursor:pointer}", ""]);

// exports
exports.locals = {
	"root": "_1cK1d",
	"button": "_1SSsM"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/desktop/components/ShareButtons/ShareButtons.css
// module id = 3170
// module chunks = 21